// extracted by mini-css-extract-plugin
module.exports = {"exchange_row":"Points_exchange_row__olsqm","logo_box":"Points_logo_box__1Eq6s"};